import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import MinInventoryByStates from './components/MinInventoryByStates';

const minInventoryByStates = (props,{ t }) => (
  <Container>
    <MinInventoryByStates {...props} />
  </Container>
);

minInventoryByStates.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(minInventoryByStates);
